import InPageNavButton from './button';
import InPageNavContainer from './container';
import InPageNavContent from './content';
import InPageNavItem from './item';
export { InPageNavContainer, InPageNavItem, InPageNavButton, InPageNavContent };
